import classNames from 'classnames'
import { Typography } from 'component_library/1_Atoms'
import Button from 'component_library/1_Atoms/Button'
import styles from './index.module.scss'

type ShowHideMapButtonProps = {
  isMapModeActive: boolean
  handleOnClick: () => void
  className?: string
}

const ShowHideMapButton: React.FC<ShowHideMapButtonProps> = ({
  isMapModeActive,
  handleOnClick,
  className,
}) => {
  return (
    <Button
      variant="navy"
      className={classNames(
        styles.loadMapButton_button,
        '~bottom-[36px]',
        '~transition-all ~duration-300 ~ease-in-out',
        className
      )}
      onClick={handleOnClick}
    >
      <img
        src="/icons/MapTrifold.svg"
        alt="show/hide map"
        width={26}
        height={26}
        className={styles.loadMapButton_icon}
      />
      <Typography color="white">
        {isMapModeActive ? 'Hide Map' : 'Show Map'}
      </Typography>
    </Button>
  )
}

export default ShowHideMapButton
